import jApi from './jApi';

export default {
  companyCreateLocation(req) {
    const api = jApi.generateApi();
    return api.post('company/setup/location/create', req)
      .then(res => res.data);
  },
  companyListLocation(req) {
    const api = jApi.generateApi();
    return api.post('company/setup/location/list', req)
      .then(res => res.data);
  },
  companyDeleteLocation(req) {
    const api = jApi.generateApi();
    return api.post('company/setup/location/delete', req)
      .then(res => res.data);
  },
  companyUpdateLocation(id, req) {
    const api = jApi.generateApi();
    return api.post(`company/setup/location/update/${id}`, req)
      .then(res => res.data);
  },
  companyDetailLocation(id) {
    const api = jApi.generateApi();
    return api.get(`company/setup/location/detail${id}`)
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiLocation.js